import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiPost, apiGet } from "../utils/api";
import PlatformSettingsCard from "./PlatformSettingsCard";

const PodcastFeedSettingsView = () => {
  const { feedId } = useParams();
  const navigate = useNavigate();
  
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (feedId) {
      loadFeed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedId]);

  const loadFeed = async () => {
    try {
      setLoading(true);
      const response = await apiGet(`/getPodcastFeed`, { feedId });
      setFeed(response.feed);
      setError(null);
    } catch (err) {
      console.error("Error loading feed:", err);
      setError("Failed to load feed settings. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAutoProcessingToggle = async () => {
    try {
      const newValue = feed.autoProcessingEnabled === false ? true : false;
      
      await apiPost('/updateFeedPreference', {
        feedId,
        autoProcessingEnabled: newValue
      });
      
      setFeed(prev => ({
        ...prev,
        autoProcessingEnabled: newValue
      }));
    } catch (err) {
      console.error("Error updating auto-processing setting:", err);
      setError("Failed to update auto-processing setting. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="feed-settings-container">
        <div className="feed-loading">
          Loading feed settings...
        </div>
      </div>
    );
  }

  if (error && !feed) {
    return (
      <div className="feed-settings-container">
        <div className="feed-error-container">
          <div className="feed-error-message">{error}</div>
          <button
            onClick={() => navigate("/feeds")}
            className="feed-retry-btn"
          >
            Back to Feeds
          </button>
        </div>
      </div>
    );
  }

  if (!feed) {
    return (
      <div className="feed-settings-container">
        <div className="feed-error-container">
          <div className="feed-error-message">Feed not found.</div>
          <button
            onClick={() => navigate(`/feeds/${feedId}`)}
            className="feed-retry-btn"
          >
            Back to Episodes
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="feed-settings-container">
      <div className="feed-header">
        <h1 className="feed-title">
          {feed.title || "Podcast Feed"} Settings
        </h1>
        <button
          onClick={() => navigate(`/feeds/${feedId}`)}
          className="feed-settings-btn"
        >
          ← Back to Episodes
        </button>
      </div>

      {/* Auto-Processing Banner */}
      <div className="general-banner">
        <div className="banner-info">
          <h3>Auto-Processing</h3>
          <p>Automatically process new episodes for all enabled platforms</p>
        </div>
        <div 
          className={`toggle ${feed.autoProcessingEnabled !== false ? 'on' : ''}`}
          onClick={handleAutoProcessingToggle}
          style={{ cursor: 'pointer' }}
        ></div>
      </div>

      {error && (
        <div className="feed-error-message" style={{ marginBottom: '20px' }}>
          {error}
        </div>
      )}

      {/* Platform Cards Grid */}
      <div className="compact-grid">
        <PlatformSettingsCard 
          platform="facebook" 
          feedId={feedId} 
          feedName={feed.title || "Podcast Feed"} 
        />
        <PlatformSettingsCard 
          platform="instagram" 
          feedId={feedId} 
          feedName={feed.title || "Podcast Feed"} 
        />
        <PlatformSettingsCard 
          platform="linkedin" 
          feedId={feedId} 
          feedName={feed.title || "Podcast Feed"} 
        />
        <PlatformSettingsCard 
          platform="x" 
          feedId={feedId} 
          feedName={feed.title || "Podcast Feed"} 
        />
      </div>
    </div>
  );
};

export default PodcastFeedSettingsView;